import React, { useEffect, useState } from "react";
import Spinner from "react-bootstrap/Spinner";
import { Modal, ProgressBar } from "react-bootstrap";

const Loader = ({ duration = 3000 }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const startTime = Date.now();

    const interval = setInterval(() => {
      const elapsed = Date.now() - startTime;
      const percentage = Math.min((elapsed / duration) * 100, 100);
      setProgress(percentage);

      if (percentage >= 100) {
        clearInterval(interval);
      }
    }, 100); // update every 100ms

    return () => clearInterval(interval);
  }, [duration]);

  return (
    <Modal size="xl" show={true} id="loader-popup">
      <Modal.Body
        style={{
          height: "80vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div className="d-flex align-items-center justify-content-center mb-4">
          <Spinner
            animation="border"
            role="status"
            size="xl"
            variant="light"
            style={{ width: "4rem", height: "4rem" }}
          />
          <p
            style={{
              fontSize: "24px",
              color: "white",
              marginLeft: "20px",
              marginBottom: 0,
            }}
          >
            Loading...
          </p>
        </div>
        <div style={{ width: "60%" }}>
          <ProgressBar
            now={progress}
            label={`${Math.floor(progress)}%`}
            animated
            variant="info"
            striped
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default Loader;
